import {ComponentType, memo} from "react";

/**
 * Pass a condition that is expected to be narrowed by TS to `never`, e.g. a
 * switch condition. Prevents compilation if not all cases are handled.
 */
export function unreachableCase(_c: never): never {
  throw new Error("Unreachable");
}

/** Like `unreachableCase`, doing nothing at runtime, for values from a backend that may be newer than this bundle. */
export function assertAllCasesHandled(_c: never): void {}

// Convert a promise-returning function, to a void-promise-returning function.
// Typescript doesn't do this conversion automatically, and we want to check that
// the argument types still match.
export function ignoreAsyncResult<A extends any[], R>(f: (...args: A) => Promise<R>): (...args: A) => Promise<void> {
  return f as any;
}

/**
 * React memo does not preserve generic prop types, so use this if you're using
 * a generic component.
 *
 * https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
 */
export function typedMemo<C extends ComponentType<any>>(Component: C): C {
  return memo(Component) as unknown as C;
}

export type OptionalIfUndefined<T> = undefined extends T ? [params?: T] : [params: T];

/** Use to extract the inner type from an array, map, set, etc. */
export type ElementType<T extends Iterable<any>> = T extends Iterable<infer U> ? U : never;

/**
 * Evaluates to `true` if T and U are equal, `false` otherwise.
 *
 * See: https://github.com/microsoft/TypeScript/issues/27024#issuecomment-421529650
 */
export type Equals<T, U> = (<A>() => A extends T ? 1 : 2) extends <A>() => A extends U ? 1 : 2 ? true : false;

/** No-op function that asserts that types `T` and `U` are equal. Prevents compilation if not. */
export function assertTypesEqual<T, U>(..._args: Equals<T, U> extends true ? [] : [never]): void {}

export function typedKeys<T extends Record<string, any>>(obj: T) {
  return Object.keys(obj) as (keyof T)[];
}

export function typedEntries<T extends Record<string, any>>(obj: T) {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
}

export function typedIncludes<T, A extends T>(array: ReadonlyArray<A>, value: T): value is A {
  return array.includes(value as any);
}

export function notNullish<T>(value: T | null | undefined): value is T {
  return value != null;
}
